/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_List_EmptyInputs */



/**
* | output |
* | --- |
* | "No active sanctions." |
*
* @param {Sanction_List_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_list_empty = /** @type {((inputs?: Sanction_List_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_List_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune sanction active.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay sanciones activas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma sanção ativa.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna sanzione attiva.")
	return /** @type {LocalizedString} */ ("No active sanctions.")
});